import React from 'react';
import styled from 'styled-components';

interface SectionProps {
    children: React.ReactNode;
    backgroundColor?: string;
    fullHeight?: boolean;
    padding?: string;
    thin?: boolean;
    textOnly?: boolean;
    maxHeightMobile?: string;
    customHeight?: string;
}

// eslint-disable-next-line no-unexpected-multiline
const StyledSection = styled.section<{
    $backgroundColor?: string;
    $fullHeight?: boolean;
    $padding?: string;
    $thin?: boolean;
    $textOnly?: boolean;
    $maxHeightMobile?: string;
    $customHeight?: string;
}>`
    background-color: ${({ $backgroundColor, theme }) =>
        $backgroundColor || theme.colors.backgroundDark};
    min-height: ${({ $fullHeight, $thin, $textOnly, $customHeight }) =>
        $customHeight || ($fullHeight ? '100vh' : $thin || $textOnly ? 'auto' : '120vh')};
    padding: ${({ $padding, $thin, $textOnly, $fullHeight, theme }) =>
            $padding ||
            ($fullHeight
                ? '0'
                : $thin
                ? theme.spacing.xxl
                : $textOnly
                ? theme.spacing.section
                : theme.spacing.section)}
        ${({ $padding, $fullHeight, theme }) => ($fullHeight ? '0' : theme.spacing.md)};
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: ${({ $thin, $textOnly, $fullHeight, theme }) =>
                $fullHeight
                    ? '0'
                    : $thin
                    ? theme.spacing.lg
                    : $textOnly
                    ? theme.spacing.xxl
                    : theme.spacing.xl}
            ${({ $fullHeight, theme }) => ($fullHeight ? '0' : theme.spacing.sm)};
        min-height: ${({ $fullHeight, $thin, $textOnly, $maxHeightMobile }) =>
            $maxHeightMobile || ($fullHeight ? '100vh' : $thin || $textOnly ? 'auto' : '100vh')};
        max-height: ${({ $maxHeightMobile }) => $maxHeightMobile || 'none'};
    }
`;

export const Section: React.FC<SectionProps> = ({
    children,
    backgroundColor,
    fullHeight,
    padding,
    thin,
    textOnly,
    maxHeightMobile,
    customHeight,
}) => {
    return (
        <StyledSection
            $backgroundColor={backgroundColor}
            $fullHeight={fullHeight}
            $padding={padding}
            $thin={thin}
            $textOnly={textOnly}
            $maxHeightMobile={maxHeightMobile}
            $customHeight={customHeight}
        >
            {children}
        </StyledSection>
    );
};
